import { render, staticRenderFns } from "./DialogRatingDoneForm.vue?vue&type=template&id=68126ec4&scoped=true&"
import script from "./DialogRatingDoneForm.vue?vue&type=script&lang=js&"
export * from "./DialogRatingDoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68126ec4",
  null
  
)

export default component.exports